export const STAFF_EVENT = 'STAFF_EVENT';
export const RESIDENCE_EVENT = 'RESIDENCE_EVENT';

export enum EVENT_TYPE {
  STAFF_EVENT,
  RESIDENCE_EVENT,
}
